import React, { useImperativeHandle, useState } from "react";
import { useTranslation } from "@/langs/useTranslation";
import SingleSelector from "../SingleSelector";

const ScheduleTasks = React.forwardRef(
  ({ disabled, name, value, onChange }, ref) => {
    const { t } = useTranslation("powerManagement");
    const [tasks] = useState([
      {
        id: "start",
        name: t("dialog.powerOn"),
        type: "windows"
      },
      {
        id: "shutdown",
        name: t("dialog.powerOff"),
        type: "both"
      },
      {
        id: "open_screen",
        name: t("dialog.wakeUp"),
        type: "android"
      },
      {
        id: "close_screen",
        name: t("dialog.sleep"),
        type: "android"
      },
      {
        id: "reboot",
        name: t("dialog.reboot"),
        type: "both"
      },
      {
        id: "start_app",
        name: t("dialog.start_app"),
        type: "both"
      },
      {
        id: "close_app",
        name: t("dialog.close_app"),
        type: "both"
      }
    ]);

    useImperativeHandle(ref, () => ({
      getOptions: () => tasks
    }));

    return (
      <SingleSelector
        placeholder={t({ defaultMessage: "选择任务" })}
        options={tasks}
        clearable
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
      />
    );
  }
);

export default ScheduleTasks;
